export const syncAnimations = () => {
  document.getAnimations()?.forEach((animation) => (animation.startTime = 0));
};
